import ApiService from "../ApiService";
const { REACT_APP_REST_ENDPOINT } = process.env;

export default class ScontiService {

  static getScontiByIdUtente = (id_utente) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/sconti/findByIdUtente`;
      ApiService.postRequest(resolve, reject, url, { id_utente });
    });
  };

  static createSconto = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/sconti/create`;
      ApiService.postRequest(resolve, reject, url, data);
    });
  };

  static deleteSconto = (id_sconto) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/sconti/delete`;
      ApiService.delete(resolve, reject, url, { id_sconto });
    });
  };

  static getScontoByIdCorso = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/sconti/findByIdCorso`;
      ApiService.postRequest(resolve, reject, url, data);
    });
  };

  static getVoucherByIdCorso = (data) => {//NEW
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/sconti/findVoucherByIdCorso`;
      ApiService.postRequest(resolve, reject, url, data);
    });
  };
}
